import styled, { css } from 'styled-components';
import Button from '../../button/Button';
export const SwapPairSectionContainer = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  border-radius: ${({ theme }) => theme.borderRadius.highM};

  ${({ hasBackground, theme }) => !hasBackground
    ? css `
          margin-top: 2.4rem;
          padding: 2.4rem 2.2rem;
          background-color: ${theme.colors.surface.default};
        `
    : ``}

  ${({ theme }) => theme.media.tabletL `
    padding: 3.2rem 3.8rem;

    background-color: ${theme.colors.surface.default};

    box-shadow: ${theme.shadows.sm};
  `};
`;
export const SwapPairHeader = styled.div `
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  width: 100%;

  padding: 6.2rem 0;
  margin-top: -4rem;

  ${({ hasBackground, theme }) => hasBackground
    ? css `
          background: radial-gradient(
            ellipse at center,
            rgba(41, 104, 241, 0.5),
            ${theme.colors.surface.interactiveDefault}
          );
        `
    : css `
          margin-bottom: 5.2rem;
          margin-top: 0;
          padding: 0;
        `};

  ${({ theme, hasBackground }) => theme.media.tabletL `
    padding: 0;
    margin-top: 0;
    margin-bottom: ${(hasBackground ? '6rem' : '3.4rem')};
    
    background: none;
  `};
`;
export const FinishedIcon = styled.div `
  width: 9rem;
  height: 9rem;

  margin-bottom: 2rem;
  background-color: inherit;

  ${({ theme }) => theme.media.tabletL `
    margin-bottom: 0.8rem;
  `};
`;
export const SwapTradePairContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  padding: 0 1.6rem;
  margin-top: -4rem;

  ${({ theme }) => theme.media.tabletL `
    margin-top: 0rem;
    padding: 0;
  `};
`;
export const ContentWrapper = styled.div `
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  margin-top: -4rem;
  padding: 6.1rem 2.1rem 0.8rem;

  border-bottom-left-radius: ${({ theme }) => theme.borderRadius.highM};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius.highM};

  background-color: ${({ theme }) => theme.colors.surface.default};

  z-index: ${({ theme }) => theme.zIndex.low};

  ${({ theme, hasExpired }) => theme.media.tabletL `
    margin-top: -4.6rem;
    padding: 7.4rem 2.1rem 1.8rem;

    border-radius: ${theme.borderRadius.highM};

   ${(!hasExpired
    ? `background-color: ${theme.colors.surface.interactiveDefault};`
    : `border: 1px solid ${theme.colors.borders.default}`)}
  `};
`;
export const TimerLine = styled.div `
  position: absolute;
  top: 7.4rem;
  left: 0;

  height: 0.1rem;
  width: 100%;
  background: ${({ background }) => background};

  z-index: -1;

  ${({ theme }) => theme.media.tabletL `
    top: 8.8rem;
  `};
`;
export const Description = styled.div `
  width: 100%;

  margin-top: 1.2rem;

  text-align: center;

  ${({ theme }) => theme.media.tabletL `
    margin-top: 2.4rem;
  `};
`;
export const CustomButton = styled(Button) `
  max-width: 24rem;

  margin-top: 1.4rem;

  ${({ theme }) => theme.media.tabletL `
    margin-top: 3.2rem;
  `};
`;
export const ProgressBarWrapper = styled.div `
  width: calc(100% - 4.4rem);

  padding: 2.2rem 3.2rem 4.5rem;
  margin: 2.4rem 2.2rem 1.6rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};

  ${({ theme }) => theme.media.tabletL `
    width: 100%;

    margin:0;
    margin-top: 2.4rem;
    padding: 2.2rem 4.6rem 3.2rem;

    border-radius: ${theme.borderRadius.high};
  `};
`;
export const SwapTradePairContainer = styled.div `
  width: 100%;

  height: min-content;

  padding: 0.1rem;

  border-radius: ${({ theme }) => theme.borderRadius.highL};

  background: ${({ theme }) => `linear-gradient(to bottom, ${theme.colors.borders.default} 0%, ${theme.colors.surface.default} 100%)`};

  box-shadow: ${({ theme }) => theme.shadows.xl};

  z-index: ${({ theme }) => theme.zIndex.medium};

  ${({ theme }) => theme.media.tabletL `
    max-width: 55rem;
  `};
`;
export const SwapTradePairContent = styled.div `
  position: relative;

  display: flex;
  justify-content: space-evenly;
  align-items: center;

  width: 100%;

  padding: 3rem 2rem 2rem;

  border-radius: ${({ theme }) => theme.borderRadius.highL};

  background-color: ${({ theme }) => theme.colors.surface.default};

  box-shadow: ${({ theme }) => theme.shadows.xl3};

  ${({ theme }) => theme.media.tabletL `
    padding: 2.8rem 2rem;
  `};
`;
export const MainBlock = styled.div `
  position: relative;

  display: flex;
  justify-content: center;

  width: calc(50% - 3rem);

  &:first-child {
    margin-right: 6rem;
  }

  img {
    width: 2.8rem;
    height: 2.8rem;
  }

  ${({ theme }) => theme.media.tabletL `
    img {
      width: 3.6rem;
      height: 3.6rem;
    }
  `};
`;
export const Title = styled.div `
  position: absolute;

  bottom: calc(100% + 0.6rem);
  left: 50%;

  padding: 0 1rem;

  background-color: ${({ theme }) => theme.colors.surface.default};

  transform: translate(-50%, 0);

  ${({ theme }) => theme.media.tabletL `
    top: -2.8rem;
    bottom: initial;

    transform: translate(-50%, -50%);
  `};
  width: max-content;
`;
export const VerticalLine = styled.div `
  position: absolute;
  left: 50%;
  top: 0.8rem;
  height: calc(100% - 1.6rem);

  border: 1px solid ${({ theme }) => theme.colors.borders.default};

  ${({ theme }) => theme.media.tabletL `
    display: none;
`};
`;
export const IconWrapper = styled.div `
  position: absolute;
  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);

  display: flex;
  align-items: center;
  justify-content: center;

  width: 4rem;
  height: 4rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.surface.default};

  z-index: ${({ theme }) => theme.zIndex.medium};

  ${({ theme }) => theme.media.tabletL `
    background-color: ${theme.colors.surface.interactiveDefault};
  `};
`;
//# sourceMappingURL=styles.js.map